export default __webpack_public_path__ + "static/media/bottom-icon.74be71b3.png";